import * as angular from 'angular';
import { AuctionResource } from '../_resources/auction.resource';

class BalancingGroupSelectionComponentCtrl implements ng.IController {
    public balancingGroups: string[];
    public undiscountedBalancingGroups: string[];
    public selectedBalancingGroup: string;
    public isMandatory: boolean;
    public isUndiscounted: boolean;
    public tsoNameForHelp: string;
    public verificationByUser: boolean;
    public direction: Direction;
    public tsoNumber: number;
    public columnWidthLabel: number;
    public columnWidthSelection: number;
    public columnWidthGeneral: number;
    public formGroupForSelection: boolean;

    public ngModelCtrl: ng.INgModelController;

    constructor(private auctionResource: AuctionResource) {}

    $onInit(): void {
        this.ngModelCtrl.$render = () => {
            this.selectedBalancingGroup = this.ngModelCtrl.$modelValue;
            this.ngModelCtrl.$setViewValue(this.selectedBalancingGroup);
        };
    }

    public onChange(): void {
        this.ngModelCtrl.$setViewValue(this.selectedBalancingGroup);
    }
}

angular.module('app').component('pkpBalancingGroupSelection', {
    controller: BalancingGroupSelectionComponentCtrl,
    template: require('app/_directives/balancing-group-selection.component.html'),
    bindings: {
        balancingGroups: '<',
        undiscountedBalancingGroups: '<',
        nonUndiscountedTariffsSupported: '=',
        isMandatory: '<',
        isUndiscounted: '<',
        tsoNameForHelp: '<',
        verificationByUser: '=',
        direction: '<',
        tsoNumber: '<',
        columnWidthLabel: '<',
        columnWidthSelection: '<',
        columnWidthGeneral: '<',
        formGroupForSelection: '<'
    },
    require: {
        ngModelCtrl: 'ngModel'
    }
});
